import {List} from 'immutable'

const funeralHomeDefaultViewItemIds = List([
  'adf74505-ff9e-4945-b8fd-0282c0a22756', // Funeral Preferences
  '2e669719-d3e5-4d0c-9d32-d61c38fe14c3', // Final Arrangements
  '777dd0d2-c916-4ddb-b543-0ace101c50f0', // Legacy Recording
  '4add6779-c3aa-44ad-8b0a-1b8084eb85d1', // IDs and Vital Documentation
  'e5b01ac5-ceea-4082-9f30-85e761ac7d12', // My Contact Info
  '92c59533-3b77-46f3-81d9-ec3fe93b8e5a', // Employment
  'bd8dae70-6e82-4dcd-9991-b0571a3f0da8', // Education/Degrees and Certifications
  '41d4832e-11c1-4ad8-82c2-b55aec69ec3f', // My Spouse/Partner
  '8c094ce6-8e42-4c5f-b8a4-80a9f6235ebf', // Obituary
  'ad3f1c5a-91d3-409d-85d7-1701c07db121' // Parents
])

export default funeralHomeDefaultViewItemIds
